import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss']
})
export class SupportComponent implements OnInit {


  constructor() { }

  ngOnInit(): void {
  }

  goToHelpDesk() {
    //TODO: This function should send to Help Desk
  }

  goToCallUs() {
    //TODO: This function should send to Call
  }

  goToMessage() {
    //TODO: This function should send to Chat
  }
}
